import {
  CustomObservations,
  MaybeCustomObservationType,
} from 'components-modules/observations/shared/observations-custom.js';

export const ActivityObservations = ({ items, intro }: { items?: MaybeCustomObservationType[]; intro: string }) => {
  if (items) {
    return (
      <>
        {intro && <p className="u-mT">{intro}</p>}
        <div className="grid-list">
          <CustomObservations customObservation={items} />
        </div>
      </>
    );
  }
  return <> {intro && <p className="u-mT">{intro}</p>}</>;
};
